import React, { useContext, useEffect, useState, useRef } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { CotizadorCRDataContext } from '../../context/CotizadorCRDataContext';


const Step8 = ({ ...rest }) => {

    const { poliza, setPoliza, polizaChangeHandler } = useContext(CotizadorCRDataContext);
    const [useCaptcha, setUseCaptcha] = useState(true);
    const captchaRef = useRef(null);




    const onAcceptChange = (e) => {
        if (e.target.checked)
            setPoliza({ ...poliza, aceptaTermino: e.target.checked })
    }

    const onReCAPTCHAChange = (value) => {
        setPoliza(({
            ...poliza,
            captcha: value,
            showCaptchaValidation: (value === null)
        }));

        setUseCaptcha(value === null);
    }



    return (
        <div className="reponsive">

            <div className="reponsive-width-12">
                <div className="bg-border-box">
                    <h5 className='txt-center bg-gray'>DECLARACIONES DEL PROPUESTO ASEGURADO</h5>
                    <p>
                        Declaro y acepto que los datos brindados anteriormente son exactos y verídicos. Asimismo, declaro y acepto que cualquier omisión voluntaria declaración falsa eximirá a SEGUROS LAFISE COSTA RICA S.A, del pago de reclamaciones, de acuerdo con el Artículo 32 de la Ley Reguladora del Contrato de Seguros N' 8956. Cualquier cambio o modificación de la información aquí suministrada, deberá ser notificado a SEGUROS LAFISE COSTA RICA S.A.
                        Hago constar que he recibido conforme y previo al perfeccionamiento del contrato, la información sobre el presente contrato de seguro, así como las Condiciones Generales del Seguro, las cuales puedo revisar accediendo a las siguientes páginas web: Seguros Lafise: https://www.lafise.com/slcr/
                    </p>

                    <h5 className='txt-center bg-gray'>CONSENTIMIENTO INFORMADO</h5>
                    <p>
                        De acuerdo con lo establecido en la Ley de Protección de la Persona frente al Tratamiento de sus Datos Personales (Ley 8368), le informamos lo siguiente:
                        <br />
                        La información brindada por usted como parte del proceso de contratación de un seguro con SEGUROS LAFISE, será almacenada en una base de datos de carácter personal nacional o internacional, con la finalidad de ofrecerte los servicios y coberturas adquiridos en el seguro. Adicionalmente, la información será uiizada en el ofrecimiento de productos y cualquier otro servicio brindado por SEGUROS LAFISE,
                        <br />
                        SEGUROS LAFISE COSTA RICA S.A, entidad con cédula jurídica 3-101-678807, será la destinataria dela información personal brindada por usted, la cual podrá ser consultada tanto por el personal de SEGUROS LAFISE, así como las personas con las que SEGUROS LAFISE mantenga algún tipo de relación comercial, y cuenten con autorización por parte de SEGUROS LAFSE, a quienes se les podrá transferir la información con los fines antes descritos. La información brindada por usted es facultativa, no obstante, en caso de oponerse, SEGUROS LAFISE se podría ver imposibilitado de brindarle algunos de los servicios contratados. Como titular de los datos personales, SEGUROS LAFISE le brinda el derecho de acceso, verificación, rectificación o eliminación de los mismos. Con pleno conocimiento de los señalado anteriormente, brindo el consentimiento para el tratamiento de mis datos personales.
                    </p>


                    <h5 className='txt-center bg-gray'>PROCESO DE ANÁLISIS (ACEPTACIÓN O RECHAZO) DE LA SOLICITUD</h5>
                    <p>
                        La solicitud de seguro que cumpla con todos los requerimientos deberá ser aceptada o rechazada dentro de un plazo máximo de treinta (30) días naturales, contados a partir de la fecha de su recibo. Si SEGUROS LAFISE no se pronuncia dentro del plazo establecido, la solicitud de seguro se entenderá aceptada. En casos de complejidad excepcional, SEGUROS LAFISE deberá indicar al solicitante la fecha posterior en que se pronunciará, la cual no podrá exceder de dos (2) meses
                        <br />
                        <strong>
                            La documentación contractual y la nota técnica que integran este producto, están registrados ante la Superintendencia General de Seguros de conformidad con lo dispuesto por el artículo 29, inciso d) de la Ley Reguladora del Mercado de Seguros, Ley 8653, bajo el registro número GO1-01-A14-715, de fecha 08 de Junio de 2017.
                        </strong>

                    </p>

                </div>
            </div>
            <br />
            <br />

            {
                <div className='reponsive-width-12'>
                    <div className="box-pl5-pr5 mt-30 pl-30">
                        <div>
                            <input type="checkbox" name="" id="teminosycondiciones" checked={poliza.aceptaTermino} required onChange={onAcceptChange} />
                            <label htmlFor="teminosycondiciones" className='lbl-t lbl-color' style={{ textAlign: "justify" }}>
                                Acepto la <a className='lbl-color-secondary lbl-lk' rel='noreferrer' href="https://www.lafise.com/terminos-y-condiciones-de-uso" target='_blank'>Política de tratamiento de datos.</a>
                            </label>

                        </div>
                    </div>
                </div>
            }
            <div className="reponsive-width-12">
                <div className="box-pl5-pr5 pl-30 mt-30">
                    {

                        <div>
                            <br />
                            <ReCAPTCHA onChange={onReCAPTCHAChange} useRef={captchaRef} sitekey='6Lfsl0UfAAAAAACaOD7IEP__fbkyPddWTFz1Z1sn' required={true} />
                            {
                                useCaptcha &&
                                <span style={{ backgroundColor: 'red' }} className='lbl-t'> Seleccione la casilla no soy un robot</span>
                            }

                        </div>
                    }
                </div>
            </div>

        </div>
    );
}

export default Step8;
